import { Component, OnDestroy, OnInit } from '@angular/core';
import { Address, SeoOptions } from '@box-types';
import { AddressesService, SEOService } from '@box-core/services';
import { Subscription } from 'rxjs';
import { deleteJsonLd } from '@box/utils';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalStateService } from '@box-core/services/global-state.service';

@Component({
  selector: 'account-addresses',
  templateUrl: './account-addresses.page.html',
  styleUrls: ['./account-addresses.page.scss']
})
export class AccountAddressesPage implements OnInit, OnDestroy {
  public addresses: Address[];
  public hasAddresses: boolean;
  private addressesSubscription: Subscription;

  constructor(
    private addressesService: AddressesService,
    private activatedRoute: ActivatedRoute,
    private seoService: SEOService,
    private router: Router,
    private globalStateService: GlobalStateService
  ) {
    this.setAddressSubscription();
  }

  ngOnInit(): void {
    this.setMetaTags();
  }

  ngOnDestroy(): void {
    this.addressesSubscription?.unsubscribe();
    deleteJsonLd();
  }

  private setAddressSubscription(): void {
    this.addressesSubscription = this.globalStateService.addresses$.subscribe((addresses) => {
      this.addresses = addresses;
      this.hasAddresses = Boolean(this.addresses?.length);
    });
  }

  public onAddAddress(): void {
    this.addressesService.initiateAddFullAddressDialogFlow$().subscribe();
  }

  public onEditAddress(address: Address): void {
    this.addressesService.initiateEditAddressDialogFlow$(true, address).subscribe();
  }

  public onDeleteAddress(address: Address): void {
    this.addressesService.initiateDeleteAddressDialogFlow$(address).subscribe();
  }

  private setMetaTags(): void {
    const options: SeoOptions = { title: this.activatedRoute.snapshot.data.breadcrumbName, url: this.router.url };
    this.seoService.setTags(options);
  }
}
